import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import WOW from "wowjs";
import EverestImage from "../images/Picture21.jpg"; // Update the image file path
import "../App.css";

const Peak = () => {
  useEffect(() => {
    new WOW.WOW({ live: false }).init();
  }, []);

  return (
    <section className="about-section py-5">
      <Container>
        <Row className="align-items-center">
          {/* Title */}
          <h2 className="text-center mb-4" style={{ fontSize: "40px" }}>
          The Story of Everest
          </h2>

          {/* Text Section */}

          <Col
            lg={6}
            className="position-relative wow animate__animated animate__fadeInRight"
            data-wow-duration="1.5s"
          >
            <div className="image-wrapper position-relative">
              <img
                src={EverestImage}
                alt="Mount Everest"
                className="img-fluid rounded shadow"
                style={{
                  border: "2px solid #d7a449",
                  padding: "5px",
                }}
              />
              {/* <div
                className="overlay-box position-absolute"
                style={{
                  bottom: "20px",
                  left: "20px",
                  backgroundColor: "#fff",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)",
                }}
              >
                <span className="text-dark">
                  <strong>5 Years</strong> <br /> Experience Working
                </span>
              </div> */}
            </div>
          </Col>
          <Col
            lg={6}
            className="wow animate__animated animate__fadeInLeft"
            data-wow-duration="1.5s"
          >
            <p className="text-muted" style={{ lineHeight: "1.8em" }}>
              In 1814, the Anglo-Nepalese war took place, and by 1818, the fall
              of the Maratha Empire brought the entire Indian subcontinent
              under British control. The British began detailed surveys,
              incorporating trigonometric methods to measure the height of
              mountain peaks, such as Nanda Devi and Kanchanjunga.
              <br />
              <br />
              By 1856, Radhanath Sikdar, a renowned Bengali mathematician,
              calculated the height of Peak XV (now Mount Everest) as 29,002
              feet, confirming it as the tallest peak. The peak was later named
              Everest in 1865 by Andrew Waugh to honor Sir George Everest,
              despite his disapproval. Today, it is locally known as
              “Chomolungma” in Tibetan and “Sagarmatha” in Nepali.
            </p>
            <a
              href={`${process.env.PUBLIC_URL}/the-story-of-heighst-peak.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{ width: "250px" }}
            >
              Read More
            </a>
          </Col>

          {/* Image Section */}
          
        </Row>
      </Container>
    </section>
  );
};

export default Peak;
